type CollateralTypeInfo = {
    title: string;
};

export const collateralTypesMap: Record<string, CollateralTypeInfo> = {
    REAL_ESTATE: {
        title: 'realEstate',
    },
    VEHICLES: {
        title: 'vehicles',
    },
    EQUIPMENT_AND_MACHINERY: {
        title: 'equipmentAndMachinery',
    },
    SECURITIES: {
        title: 'securities',
    },
    OTHER: {
        title: 'other',
    },
};

export const collateralTypeOptions = Object.entries(collateralTypesMap).map(
    ([key, info]) => {
        return {
            id: key,
            title: info.title,
            'data-testid': `collateral-type-${key}`,
        };
    },
);
